import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import moment from "moment";
import styled from "styled-components";

class Lockout extends React.Component {
  componentDidMount() {
    const { startDate, endDate } = this.props;
    this.setDescription(startDate, endDate);
  }

  componentDidUpdate(prevProps) {
    const { startDate, endDate } = this.props;
    const { startDate: prevStartDate, endDate: prevEndDate } = prevProps;
    if (startDate !== prevStartDate || endDate !== prevEndDate) {
      this.setDescription(startDate, endDate);
    }
  }

  setDescription(startDate, endDate) {
    if (endDate) {
      const description = `Prepayment prohibited through ${moment(endDate).format("MM/DD/YYYY")}`;
      this.props.setDescription(description);
    } else {
      this.props.setDescription("No description");
    }
  }

  render() {
    return (
      <>

      </>
    );
  }
}
export default Lockout;
